var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[(_vm.showContent)?_c('div',{staticClass:"outer-container",class:{ faded: _vm.isFaded }},[_vm._t("default")],2):_vm._e(),(_vm.showSpinner)?_c('div',{class:[
      'text-center',
      _vm.isFaded
        ? 'position-absolute d-flex justify-content-center align-items-center inset-0'
        : '' ],style:(_vm.fixedWidth ? ("width: " + _vm.fixedWidth + "px") : "")},[_c('b-spinner',{attrs:{"label":"Spinning","small":_vm.small}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }